/**
 * 获取差异数组
 * @param parentList: Array
 * @param childrenList: Array
 * @param key: String
 */
export const filterList = (parentList = [], childrenList = [], key = "id") => {
    let arr = [];
    arr = parentList.filter((item) => {
        return childrenList.every((citem) => item[key] !== citem[key]);
    });
    return arr;
};
